/** UI texts: the TradingView-style workspace (top bar, chart toolbar, watchlist, side panel, account menu). */
export const workspaceUi = {
  en: {
    // the models: the choice above the chart, the tuning beside it
    "model.label": "Model",
    "model.none": "none",
    "tune.auto.on": "On",
    "tune.auto.off": "Off",
    "tune.slots": "My tunings",
    "tune.slot.name": "Name of this tuning",
    "tune.slot.load": "Load this tuning",
    "tune.slot.save": "Save the current tuning here",
    "tune.slot.reset": "Back to its preset",
    "tune.slot.resetConfirm": "Put slot {n} back to its preset \u201c{preset}\u201d? The tuning saved there goes.",
    "tune.slot.active": "active",
    "tune.slot.failed": "The tuning could not be saved.",
    "ws.news.headlines": "Headlines",
    "ws.cal.previous": "Previous",
    "ws.cal.date": "Date",
    "ws.cal.short.date": "Date",
    "ws.cal.short.event": "Event",
    "ws.cal.short.actual": "Act.",
    "ws.cal.short.forecast": "Fcst.",
    "ws.cal.short.previous": "Prev.",
    "ws.cal.forecast": "Forecast",
    "ws.cal.actual": "Actual",
    "ws.cal.impact.none": "No impact rating",
    "ws.cal.impact.holiday": "Bank holiday",
    "ws.cal.impact.low": "Low impact",
    "ws.cal.impact.medium": "Medium impact (orange folder)",
    "ws.cal.impact.high": "High impact (red folder)",
    "ws.cal.none": "No important releases in the next days.",
    "ws.cal.error": "The economic calendar is currently unavailable.",
    "ws.cal.off": "No economic calendar configured (Settings → Market data).",
    "ws.cal.title": "Economic calendar",
    "ws.cal.now": "{title} is being released",
    "ws.cal.next": "Next high-impact release: {title} in {min}",
    "ws.symbol": "Instrument",
    "ws.search.placeholder": "Search market (symbol or name)…",
    "ws.search.noResults": "No matches",
    "ws.search.online": "Search the data provider for “{q}”",
    "ws.search.add": "Add",
    "ws.search.searching": "Searching…",
    "ws.timeframe": "Timeframe",
    "ws.market.remove": "Remove market",
    "ws.market.removeConfirm": "Remove {name} for good? Its price data and drawings are deleted; built-in markets stay.",
    "ws.watchlist": "Watchlist",
    "ws.col.price": "Price",
    "ws.col.change": "Chg",
    "ws.watchlist.remove": "Remove from watchlist",
    "ws.watchlist.empty": "Your watchlist is empty. Add a market with the search.",
    "ws.watchlist.loading": "Analysing your watchlist…",
    "ws.side.panel": "Market panel",
    "ws.side.watch": "Watchlist",
    "ws.side.market": "Market",
    "mk.head": "Checks · {tf}",
    "mk.long": "Long",
    "mk.short": "Short",
    "mk.none": "No checks yet: the market has too few bars.",
    "mk.about": "About this check",
    "mk.legend": "✓ met at the last closed bar, – not met.",
    // the Illustillo model (a Smart Money Concepts process): its tuning, its summary, its chart, its checks
    "io.name": "Illustillo",
    "io.tune": "Tuning",
    "io.title": "Illustillo tuning",
    "io.about.title": "Illustillo – the strategy",
    "io.about.intro": "A Smart Money process in seven steps — each counts only after the one before.",
    "io.about.steps": "1 Bias: the last break of structure (BOS) on the higher timeframe sets the direction; a CHoCH after it is only a first sign.\n2 Draw on liquidity: the box — the latest unbroken swing high (ceiling) and swing low (floor) of the box's timeframe.\n3 Sweep: a bar trades through liquidity and closes back inside.\n4 Displacement: then a strong break of the internal structure in the side's direction (with auto a CHoCH).\n5 POI: the open order block or fair value gap that move left.\n6 Confirmation: the return into the POI (with auto the entry itself), else another break there.\n7 Target: the draw on liquidity or multiples of the risk; with auto the London, then the Asian high or low.",
    "io.about.evidence": "No proven edge: its building blocks (sweeps, order blocks, gaps, retests, the ICT sequence) gave nothing on unseen data. A reading aid after the Smart Money principle.",
    "io.auto": "Auto",
    "io.auto.session": "running session: box edge, previous day, Asian killzone high / low, equal highs / lows",
    "io.auto.bodies": "body ≥ {x} × before",
    "io.auto.stop": "beyond the sweep's extreme",
    "io.auto.targets": "London, then Asian killzone high / low, else draw on liquidity",
    "io.targets": "Targets",
    "io.auto.poi": "both, in discount / premium, an overlap first, nearest EQ; order block = last opposite candle",
    "io.bias": "Bias",
    "io.box": "Box",
    "io.swing": "Swings",
    "io.bars": "{n} bars",
    "io.close": "Break by",
    "io.close.body": "Body close",
    "io.close.wick": "Wick",
    "io.window": "Sweep within",
    "io.displacement": "Displacement ≥",
    "io.poi": "POI",
    "io.poi.orderBlock": "Order block",
    "io.poi.fvg": "FVG",
    "io.poi.both": "Both",
    "io.poiKind.orderBlock": "Order block",
    "io.poiKind.fvg": "Fair value gap",
    "io.poiKind.breaker": "Breaker",
    "io.poiKind.supplyDemand": "Supply / demand",
    "io.entry": "Entry",
    "io.entry.near": "Near edge",
    "io.entry.mid": "Middle",
    "io.entry.far": "Far edge",
    "io.entry.row": "Entry",
    "io.stop.row": "Stop",
    "io.stopAtr": "Stop buffer",
    "io.tp": "TP{n}",
    "io.target.dol": "Draw on liquidity",
    "io.target.rr": "{rr} R",
    "io.rr": "{price} · R/R 1:{rr}",
    "io.frames": "Bias {bias} · box {box}",
    "io.bias.up": "up (last {kind})",
    "io.bias.down": "down (last {kind})",
    "io.bias.none": "none yet",
    "io.bias.turning.up": "CHoCH up — waiting for a BOS",
    "io.bias.turning.down": "CHoCH down — waiting for a BOS",
    "io.long": "Long",
    "io.short": "Short",
    "io.stage.none": "no sweep — the nearest zone in discount / premium as candidate",
    "io.stage.sweep": "swept, no displacement",
    "io.stage.displacement": "displaced, no POI",
    "io.stage.poi": "POI set, awaiting the return",
    "io.stage.inPoi": "in the POI, awaiting the ChoCH",
    "io.stage.confirmed": "confirmed",
    "io.stage.againstBias": "against the bias — no trade",
    "io.stage.wrongSide": "POI on the wrong side of the equilibrium — no trade",
    "io.preset.1": "Auto",
    "io.preset.2": "Daily bias · 4H box",
    "io.preset.3": "Scalp 1H · 15M",
    "io.chart.poi": "POI · {side}",
    "io.chart.candidate": "Candidate · {side}",
    "io.candidate": "{kind} (candidate)",
    "io.chart.stop": "{side} · Stop",
    "io.chart.tp": "{side} · TP{n} (1:{rr})",
    "chk.bias": "Bias",
    "chk.bias.hint": "Illustillo, step 1 (external structure). Long ✓ while the last BOS of the bias timeframe's structure went up, short ✓ while it went down; a CHoCH after it is only the first sign — the bias is undecided until a BOS follows in the new direction. Swings are legs of the tuned size, a level breaks by a body close (or a wick, by the tuning). Not the same as the layer “Trend direction (zigzag)”: that one reads the chart's own timeframe by 3 ATR turns, the bias a higher timeframe (with auto two steps up) by its structure breaks — both can point different ways, e.g. a short rise inside a falling 4H. The template's rule, not a measured edge: trend direction tells the past, not the future (our measurement 30.10.2026).",
    "chk.dol": "Draw on liquidity",
    "chk.dol.hint": "Illustillo, step 2. The box: the latest swing high (ceiling) and swing low (floor) of the box timeframe not broken yet — the stops resting beyond them are where price is drawn to. Long ✓ while a ceiling lies above price, short ✓ while a floor lies below it. Descriptive: which of the two breaks first is not predictable from the chart (our measurement 30.10.2026).",
    "io.chart.ceiling": "Ceiling",
    "io.chart.floor": "Floor",
    "chk.sweep": "Liquidity sweep",
    "chk.sweep.hint": "Illustillo, step 3. ✓ when a bar traded through liquidity and closed back inside — below it for long, above it for short. With auto only liquidity worth the name and within the running session: the box's floor or ceiling, the previous day's low / high, the low / high of the Asian killzone (20:00–00:00 New York, as the ICT killzone indicator draws it) or a swing in a pool of equal lows / highs; without auto any swing of the internal structure within the tuned window. The template: 'the sweep is often the entry signal'. Measured 30.10.2026 on 12 markets: a sweep alone does not change the odds.",
    "chk.displacement": "Displacement",
    "chk.displacement.hint": "Illustillo, step 4. ✓ when after the sweep the internal structure broke in the side's direction with a strong move: with auto the break is a change of character (the template's entry example: '4) CHOCH') and its biggest body (the template: 'large candles … noticeably stronger') is at least the tuned multiple of the mean body of the 20 bars before the sweep, a fair value gap not required ('often' left behind); without auto the move from the sweep's extreme to the break's close at least the tuned ATR 14 multiple. The template: 'proof smart money is pushing — no displacement, be cautious'. Our measurement: breakouts on 5M continue less often than chance (33 % vs 36 %).",
    "chk.poi": "Point of interest",
    "chk.poi.hint": "Illustillo, step 5. ✓ when the displacement left an order block or a fair value gap (by the tuning) of the side's direction that is still open — the earliest one, the move's origin; with auto only on the right side of the box's equilibrium (long in discount, short in premium), an overlap of both kinds first; the order block is the last opposite candle before the move, as the chart's order block layer draws it. It is the zone the plan hangs on: the entry at its edge, the stop beyond its far edge. Measured 30.10.2026: reactions at order blocks and gaps are at chance on unseen data. The zone is the model's on the chart.",
    "chk.confirm": "Confirmation",
    "chk.confirm.hint": "Illustillo, step 6. ✓ when price came back into the POI (mitigation) and afterwards the internal structure broke in the side's direction — with auto the return itself, as the template's entry example enters: its ChoCH is the displacement's break before the return ('4) CHOCH', '5) Returns to Bullish OB'). The plan: entry at the POI's edge; with auto the stop beyond the sweep's extreme (or the POI's far edge, whichever lies farther) plus buffer and the targets the high of the London killzone (02:00–05:00 New York), then of the Asian killzone (short: lows) beyond the entry, else the draw on liquidity (the template's example); without auto the stop beyond the POI's far edge plus buffer and the targets as tuned. Measured 30.10.2026 as a complete setup: no edge on unseen data. The stop and the targets are the model's on the chart.",
    "ws.side.news": "News",
    "ws.side.times": "Times",
    "ws.side.votes": "Voting",
    "ws.side.noMarket": "Choose a market from the watchlist — its news, trading hours and the voting appear here.",
    "ws.time.holiday": "Bank holiday today in {places} — thin trading there, erratic moves possible.",
    "ws.place.newYork": "New York",
    "ws.place.london": "London",
    "ws.place.frankfurt": "Frankfurt",
    "ws.place.tokyo": "Tokyo",
    "ws.time.sessions": "Trading sessions",
    "ws.time.s.sydney": "Sydney",
    "ws.time.s.tokyo": "Tokyo",
    "ws.time.s.london": "London",
    "ws.time.s.newyork": "New York",
    "ws.time.openUntil": "open · closes {in}",
    "ws.time.opensIn": "opens {in}",
    "ws.time.inHm": "in {h} h {m} min",
    "ws.time.inM": "in {m} min",
    "ws.time.src.babypips": "Babypips",
    "ws.time.src.jpx": "JPX",
    "ws.time.src.xetra": "Xetra",
    "ws.time.src.lse": "LSE",
    "ws.time.src.lbma": "LBMA",
    "ws.time.src.usStats": "BLS/BEA",
    "ws.time.src.nyse": "NYSE",
    "ws.time.src.lseg": "LSEG",
    "ws.time.src.cme": "CME",
    "ws.time.keyTimes": "Important times",
    "ws.source": "Source: {source}",
    "ws.sourceOf": "Source of „{title}“",
    "ws.time.k.sydneyOpen": "Sydney opens",
    "ws.time.kd.sydneyOpen": "The forex day starts with Sydney at 17:00 New York; gold reopens after its daily break at 18:00 New York",
    "ws.time.k.lbmaAm": "LBMA gold auction (AM)",
    "ws.time.kd.lbmaAm": "London gold price auction, 10:30 London — the reference price for gold",
    "ws.time.k.lbmaPm": "LBMA gold auction (PM)",
    "ws.time.kd.lbmaPm": "London gold price auction, 15:00 London — often more volume than in the morning",
    "ws.time.k.fxFix": "London FX fix",
    "ws.time.kd.fxFix": "WM/Reuters closing rates, 16:00 London — large currency orders, sharp moves around it",
    "ws.time.k.tokyoOpen": "Tokyo opens",
    "ws.time.kd.tokyoOpen": "Start of the Asia session",
    "ws.time.k.frankfurtOpen": "Frankfurt opens",
    "ws.time.kd.frankfurtOpen": "Xetra opens, 09:00 Frankfurt — the DAX starts trading, euro volume rises",
    "ws.time.k.lbmaSilver": "LBMA silver auction",
    "ws.time.kd.lbmaSilver": "London silver price auction, 12:00 London — the reference price for silver",
    "ws.time.k.lbmaPgmAm": "LBMA platinum/palladium (AM)",
    "ws.time.kd.lbmaPgmAm": "London platinum and palladium price auction, 09:45 London",
    "ws.time.k.lbmaPgmPm": "LBMA platinum/palladium (PM)",
    "ws.time.kd.lbmaPgmPm": "London platinum and palladium price auction, 14:00 London",
    "ws.time.k.londonOpen": "London opens",
    "ws.time.kd.londonOpen": "Start of the London session, volume rises",
    "ws.time.k.usData": "US economic data",
    "ws.time.kd.usData": "CPI, jobs report and other US data are usually released now — strong moves possible",
    "ws.time.k.nyOpen": "New York stock open",
    "ws.time.kd.nyOpen": "US stock exchanges open — often strong moves",
    "ws.time.k.dailyBreak": "Daily close",
    "ws.time.kd.dailyBreak": "Gold and currencies pause for an hour; spreads widen around it",
    "ws.acct.settings": "Settings",
    "ws.layers.title": "Layers",
    "ws.grid.help": "Background grid: off, horizontal (price steps), vertical (time steps) or checked",
    "ws.grid.label": "Grid",
    "ws.fullscreen.enter": "Full screen",
    "ws.fullscreen.exit": "Leave full screen",
    "ws.zone.label": "Time zone",
    "tz.local": "Device time",
    "tz.UTC": "UTC",
    "tz.America/New_York": "New York",
    "tz.America/Chicago": "Chicago",
    "tz.Europe/London": "London",
    "tz.Europe/Berlin": "Berlin / Frankfurt",
    "tz.Europe/Moscow": "Moscow",
    "tz.Asia/Dubai": "Dubai",
    "tz.Asia/Hong_Kong": "Hong Kong",
    "tz.Asia/Singapore": "Singapore",
    "tz.Asia/Tokyo": "Tokyo",
    "tz.Australia/Sydney": "Sydney",
    "ws.crosshair.label": "Crosshair",
    "ws.crosshair.help": "Crosshair on: lines through the pointer with its price and time on the axes — off: the chart without them (the line above still shows the candle under the pointer)",
    "ws.magnet.label": "Magnet",
    "ws.magnet.help": "Magnet on: the crosshair sticks to the candle under it (open, high, low or close) — off: it moves freely over the chart",
    "ws.grid.off": "off",
    "ws.grid.horizontal": "horizontal",
    "ws.grid.vertical": "vertical",
    "ws.grid.both": "checked",
    "ws.layers.last": "Last price (line to the axis)",
    "ws.layers.group.fib": "Fibonacci",
    "ws.layers.group.levels": "Levels & zones",
    "ws.layers.group.structure": "Structure & trend",
    "ws.layers.group.smc": "Smart Money",
    "ws.layers.group.patterns": "Chart patterns",
    "ws.layers.group.indicators": "Indicators",
    "ws.layers.group.time": "Time & news",
    "ws.layers.group.candles": "Candles",
    "ws.layers.group.view": "View",
    "ws.layers.levels": "Support / resistance / liquidity",
    "ws.layers.fvg": "Fair value gaps",
    "ws.layers.orderBlocks": "Order blocks",
    "ws.layers.breakers": "Breaker blocks",
    "ws.layers.poi": "POI (point of interest)",
    "ws.layers.supplyDemand": "Supply / demand (Seiden)",
    "ws.layers.srZones": "Support / resistance zones",
    "ws.layers.fibClusters": "Fibonacci clusters (Boroden)",
    "ws.layers.premiumDiscount": "Premium / discount",
    "ws.layers.events": "Structure (sweep / BOS)",
    "ws.layers.chains": "Entry chain (sweep → MSS → FVG)",
    "ws.layers.swingStructure": "Swing structure (HH / HL, external)",
    "ws.layers.breakRetest": "Break & retest",
    "ws.layers.doubleTops": "Double / triple top / bottom",
    "ws.layers.ifvg": "Inverse FVG",
    "ws.layers.displacement": "Displacement",
    "ws.layers.ote": "OTE zone (62–79 %)",
    "ws.layers.killzones": "Killzones (London, New York)",
    "ws.layersHint.events": "BOS: a break of the last high / low (trend on) · CHoCH: the first break against the trend (turn) · Sweep: a wick beyond a high / low, close back (stops taken)",
    "ws.layersHint.chains": "The SMC entry model: ① a swing low (high) is swept, ② within 24 bars a CHoCH the other way with a fair value gap (the MSS), ③ price runs back into the gap, ④ a bar closes out of it — the entry, the stop at the sweep. ✗ a close below the sweep or the gap before the entry. On the chart's bars, from past bars only.",
    "ws.layersHint.swingStructure": "The large swings (swing structure, 50 bars) labelled HH / HL / LH / LL against the swing before, and the breaks of this external structure (BOS / CHoCH ext.) — internal breaks are early hints, these confirm the higher trend.",
    "ws.layersHint.breakRetest": "After a BOS price comes back to the broken level within 24 bars and the close holds on the new side: resistance became support (or the other way). A close back through it first is a fakeout and is not marked.",
    "ws.layersHint.doubleTops": "Two (three) consecutive swing highs (lows) at the same level — within the tolerance of equal highs — with the neckline between them; confirmed only by a close through the neckline, void by a close beyond the tops.",
    "ws.layersHint.ifvg": "A fair value gap a close went through entirely becomes a zone of the other side (a broken bullish gap: resistance), until a close goes back through it.",
    "ws.layersHint.displacement": "The impulsive candle of a fair value gap: its body in the gap's direction at least one ATR and two thirds of the candle.",
    "ws.layersHint.ote": "The optimal trade entry of some ICT rulebooks: 62–79 % of the first Fibonacci net's rise (a buy zone) and fall (a sell zone).",
    "ws.layersHint.killzones": "ICT's killzones in New York time: London 02:00–05:00 and New York AM 07:00–10:00, on charts up to 1H — each as a box over the range traded in it.",
    "ws.layersHint.poi": "Where the move that broke the structure (BOS / CHoCH) began: its order block or fair value gap, still open and not yet revisited — green below price for buys, red above for sells. Price coming back to it is the usual entry; once touched it is no longer shown.",
    "ws.layers.ema": "EMA 20 / 50 / 200 (Golden / Death cross)",
    "ws.layers.trendZigzag": "Trend direction (zigzag)",
    "ws.layers.ribbon": "MA ribbon",
    "ws.layers.pivots": "Pivot points (classic)",
    "ws.layers.priceGaps": "Price gaps",
    "ws.layers.trendlines": "Trendlines (auto)",
    "ws.layers.headShoulders": "Head & Shoulders",
    "ws.layers.triangles": "Triangles & wedges",
    "ws.layers.divergences": "RSI divergences",
    "ws.layers.squeeze": "Bollinger squeeze",
    "ws.layersHint.trendZigzag": "The trend by directional change (Glattfelder et al. 2011): a rise lasts until price falls 3 ATR(14) below the highest high since the last turn, then a fall until it rises 3 ATR above the lowest low; a confirmed turn never changes. Drawn: the confirmed turns up to the running extreme as a zigzag, and the line „Trend turns at“ where it would turn. Measured on gold 2021–26 and ten other markets: of all live methods it names the trend seen in hindsight best for its noise, a new direction after about 7 bars on average. It states the trend, it does not forecast it.",
    "ws.layersHint.ema": "The exponential averages of 20, 50 and 200 closes; where EMA 50 crosses EMA 200 the golden cross (up) or death cross (down) is marked.",
    "ws.layersHint.ribbon": "18 exponential averages of 5 to 90 closes under the candles, blue (short) to red (long): fanned out in a trend — the wider, the stronger —, close together and twisted in a sideways market or where the direction turns.",
    "ws.layersHint.pivots": "The floor traders' pivots of the previous day (New York): pivot = (high + low + close) ÷ 3, resistances R1–R3 above, supports S1–S3 below.",
    "ws.layersHint.priceGaps": "A bar whose low lies above the high before (or whose high lies below the low before): a gap, open until price has traded it back — the part already traded back is no longer drawn.",
    "ws.layersHint.trendlines": "The support line through the last two swing lows when the second is higher, the resistance line through the last two swing highs when the second is lower — up to the first close beyond it. Quiet with two touches; from the third (one more swing on the line) it counts as confirmed and is drawn green / red.",
    "ws.layersHint.headShoulders": "Five swings — shoulder, neck, head, neck, shoulder: the head beyond both shoulders, the shoulders closer to each other than to the head, the neckline through the necks; confirmed only by a close through the neckline, void by a close beyond the right shoulder, else lapsed after 48 bars.",
    "ws.layersHint.triangles": "The last two swing highs and lows: flat highs over rising lows (ascending), flat lows under falling highs (descending), falling highs over rising lows (symmetrical); rising / falling wedges — both lines one way, converging; the first close outside is the breakout (the lines then green / red), lapsed where the lines meet or after 48 bars.",
    "ws.layersHint.divergences": "RSI (14) against two consecutive swings: regular — a higher high with a lower RSI (bearish), a lower low with a higher RSI (bullish); hidden — a lower high with a higher RSI (bearish), a higher low with a lower RSI (bullish).",
    "ws.layersHint.squeeze": "Bollinger's squeeze: the width of the bands (20, 2) at its lowest of 125 bars is marked; the first close outside the bands within 48 bars after it is the release.",
    "ws.layers.sessionLiquidity": "Session liquidity (Asia, London)",
    "ws.layers.equalLevels": "Equal highs / lows",
    "ws.layers.htfChains": "Entry chain in the HTF POI",
    "ws.layers.inducement": "Inducement",
    "ws.layers.oscillators": "Oscillator signals (RSI, stochastic, MACD)",
    "ws.layers.sideways": "Sideways phases",
    "ws.layers.volume": "Volume confirmation",
    "ws.layers.channels": "Trend channel",
    "ws.layersHint.sessionLiquidity": "The high and low of the Asian (Tokyo) and the London session, each until a later bar takes it: a wick beyond and the close back is a sweep, a close beyond a break — on charts up to 1H.",
    "ws.layersHint.equalLevels": "Two consecutive swing highs (lows) at the same level — within the tolerance of equal highs — as a line until price goes beyond it: the liquidity there is taken.",
    "ws.layersHint.htfChains": "The entry chains (sweep → MSS → FVG) that formed inside a point of interest of the higher timeframe (1H under the hour, 4H on the 1H chart): the POI drawn faintly, the chain marked „HTF ✓“.",
    "ws.layersHint.inducement": "For each point of interest still waiting: the last swing between price and it that formed after it — the early entries' stops; marked when a bar takes it before price reaches the POI.",
    "ws.layersHint.oscillators": "On the price chart, without a pane of their own: RSI 14 entering above 70 / below 30, the stochastic 14/3/3 crossing above 80 / below 20, MACD 12/26/9 crossing its signal line.",
    "ws.layersHint.sideways": "Where the closes went mostly back and forth — efficiency ratio over 20 bars below 0.16, the trend check's rule for no clear trend — for at least 10 bars: a faint box over the range traded.",
    "ws.layersHint.volume": "Breaks of structure (internal and swing) whose bar traded at least 1.5 times the mean volume of the 20 bars before — on CFDs the provider's tick volume.",
    "ws.layersHint.channels": "The parallel to each automatic trendline through the farthest bar on the other side between its two swings: the trend channel, drawn like its trendline.",
    "ws.layers.news": "News markers",
    "ws.watchlist.searchAdd": "Search a market and add it to the watchlist …",
    "ws.watchlist.dragHint": "Click: open in a tab · drag: change the order",
    "ws.tabs.label": "Open markets",
    "ws.tabs.add": "Open another market in a new tab",
    "ws.empty.title": "No market open",
    "ws.empty.hint": "Pick a market in the watchlist or find one with the search above it — it opens in a tab.",
    "ws.tabs.close": "Close the {m} tab",
    "ws.tabs.search": "Search a market …",
    "ws.layers.heikin": "Heikin Ashi candles",
    "ws.layers.walker": "Illusman",
    "ws.layers.walkerMode": "How Illusman goes: on its own (auto), on its own and steered (hybrid) or steered only (manual: arrow keys, B, J, M, joystick)",
    "ws.layers.walkerMode.auto": "Auto",
    "ws.layers.walkerMode.hybrid": "Hybrid",
    "ws.layers.walkerMode.manual": "Manual",
    "ws.layers.dayLevels": "Day levels (New York)",
    "ws.layers.vwap": "VWAP band",
    "ws.layers.bollinger": "Bollinger bands (20, 2)",
    "ws.lvl.pdh": "Prev. day high",
    "ws.lvl.pdl": "Prev. day low",
    "ws.lvl.pdc": "Prev. day close",
    "ws.lvl.poc": "POC",
    "ws.lvl.vah": "VAH",
    "ws.lvl.val": "VAL",
    "ws.lvl.onh": "Overnight high",
    "ws.lvl.onl": "Overnight low",
    "ws.lvl.orh": "OR high",
    "ws.lvl.orl": "OR low",
    "ws.lvl.ibh": "IB high",
    "ws.lvl.ibl": "IB low",
    "ws.lvl.wo": "Week open",
    "ws.lvl.pwh": "Prev. week high",
    "ws.lvl.pwl": "Prev. week low",
    "ws.lvl.round": "Round number",
    "ws.layers.fibo": "Fibonacci",
    "ws.layers.fiboFirst": "1st net",
    "ws.layers.fiboSecond": "2nd net",
    "ws.layers.fiboSides": "{net}: sides (L long ↑, S short ↓)",
    "ws.layers.fiboSide.long": "L",
    "ws.layers.fiboSide.short": "S",
    "ws.an.entry": "Entry",
    "ws.plan.side.long": "Long",
    "ws.plan.side.short": "Short",
    "notify.tip.title": "💡 New trade tip",
    "notify.tip.reward": "+{r} R",
    "notify.tip.until": "Valid for today's round, until 17:00 New York.",
    "notify.tip.vote": "Vote for or against it in Illustrading — anonymously.",
    "notify.tip.open": "🗳 Vote now",
    "notify.chosen.title": "✓ Illustrading is connected",
    "notify.chosen.lead": "New trade tips appear here from now on.",
    "vote.title": "Trade tips · {market}",
    "vote.endsIn": "Round ends in {time}",
    "vote.endsAt": "The round ends {end} (17:00 New York)",
    "vote.ended": "Round over",
    "vote.rulesTitle": "How the voting works",
    "vote.split": "{long} long, {short} short",
    "vote.sides": "Direction of the tips in this round",
    "vote.yours": "Your trade tip",
    "vote.viewOnly": "You can follow the tips and votes; giving tips and voting is not switched on for you.",
    "vote.side": "Direction",
    "vote.optional": "optional",
    "vote.pickHint": "Then tap the chart to take the price there",
    "vote.pickFromChart": "{field}: pick the price in the chart",
    "vote.give": "Give tip",
    "vote.change": "Change tip",
    "vote.delete": "Delete",
    "vote.edit": "Change this tip (while it waits for its entry)",
    "vote.editLocked": "Entered — its prices stand",
    "vote.editing": "Change your tip",
    "vote.deleteConfirm": "Delete your tip? It goes with the votes on it — also from the past rounds.",
    "vote.all": "All tips ({n})",
    "vote.none": "No tips in this round yet.",
    "vote.history": "Past rounds",
    "vote.historyNone": "No past rounds on this market.",
    "vote.agree": "For it",
    "vote.disagree": "Against it",
    "vote.opinions": "{agree} for · {disagree} against",
    "vote.guide.exampleAuthor": "Anna",
    "vote.guide.roundTitle": "A round",
    "vote.guide.round": "Every market has one round per trading day; it ends at 17:00 New York — the countdown beside the heading shows how long it runs. At its end every open tip is scored for good, and a new round begins.",
    "vote.guide.giveTitle": "Giving a tip",
    "vote.guide.give": "Choose long or short and give the entry, the stop-loss and at least TP1 (TP2 and TP3 are optional). Click into a price field and then into the chart to take the price from there. The entry must lie within 10 % of the price. You can give as many tips per round as you like; after each one the form is empty for the next.",
    "vote.guide.rowTitle": "How a tip looks",
    "vote.guide.row": "Each tip is one line: ▲ green for long, ▼ red for short, when it was given, the entry, the stop-loss in red and the targets in green (\"—\": not given). Under it the votes. On your own tips the pen and the bin sit at the right.",
    "vote.guide.details": "A click on a tip rolls out its details — try it on the example above: who gave it, how it stands, the risk (entry to stop) and each target's reward in multiples of the risk (R). Another click rolls them in.",
    "vote.guide.votesTitle": "The votes",
    "vote.guide.votes": "The others vote for or against each tip — how sure they are of the trade. The bar grows from its middle: red to the left for the votes against, green to the right for those for; the counts stand at its ends. Here 1 against and 3 for. Press 👍 or 👎 under someone else's tip to vote, the same button again to take your vote back. You can vote until a tip is scored for good; not on your own.",
    "vote.guide.sidesTitle": "The round's direction",
    "vote.guide.sides": "The bar under the heading counts the round's tips by side: short to the left, long to the right — where the community leans today, whatever the votes on single tips. Here 2 short and 5 long.",
    "vote.guide.standTitle": "Stand and result",
    "vote.guide.stand": "A tip counts from the moment it is given, measured on the prices after it (a candle reaching stop and target together counts the stop). Its stand is in its details:",
    "vote.guide.stand.waiting": "Waiting for entry",
    "vote.guide.stand.waiting.means": "The price has not reached the entry yet.",
    "vote.guide.stand.running": "Running",
    "vote.guide.stand.running.means": "Entered; neither the stop nor a target reached yet.",
    "vote.guide.stand.runningTp": "Running · TP1 reached",
    "vote.guide.stand.runningTp.means": "Entered, TP1 (or TP2) reached, the further targets still open.",
    "vote.guide.stand.stop": "Stop",
    "vote.guide.stand.stop.means": "The stop came before any target: −1 R.",
    "vote.guide.stand.tp": "TP1 / TP2 / TP3",
    "vote.guide.stand.tp.means": "The highest target reached before the stop: as many R as the target lies from the entry in multiples of the risk.",
    "vote.guide.stand.expired": "Expired",
    "vote.guide.stand.expired.means": "Entered, but neither stop nor target by the round's end: 0 R.",
    "vote.guide.stand.missed": "Not entered",
    "vote.guide.stand.missed.means": "The entry was never reached by the round's end: not counted.",
    "vote.guide.standEnd": "A tip is scored for good when its stop comes, its last target is reached or the round ends — then its stand no longer changes.",
    "vote.guide.changeTitle": "Changing and deleting",
    "vote.guide.change": "The pen loads your tip into the form, as long as it waits for its entry; once entered its prices stand (the pen is greyed). The votes on a changed tip go, they were on the old plan. The bin deletes your tip whenever — waiting, running or scored, also in past rounds — together with its votes.",
    "vote.guide.namesTitle": "Who sees what",
    "vote.guide.names": "Everyone sees every tip with its author's name (in its details). The votes are counted without names: nobody sees who voted how.",
    "vote.details.show": "Click for the tip's details",
    "vote.details.hide": "Click to fold the details away",
    "vote.details.author": "Given by",
    "vote.details.status": "Status",
    "vote.details.risk": "Risk (entry to stop)",
    "vote.details.reward": "Reward / risk",
    "vote.status.waiting": "Waiting for entry",
    "vote.status.running": "Running",
    "vote.status.runningTp": "Running · TP{n} reached",
    "vote.status.stop": "Stop",
    "vote.status.tp1": "TP1",
    "vote.status.tp2": "TP2",
    "vote.status.tp3": "TP3",
    "vote.status.expired": "Expired",
    "vote.status.missed": "Not entered",
    "vote.col.side": "Direction",
    "vote.col.time": "Given",
    "profile.title": "Profile",
    "profile.name": "Name",
    "profile.email": "E-mail",
    "profile.password": "Password",
    "profile.save": "Save",
    "profile.newEmail": "New e-mail",
    "profile.currentPassword": "Current password",
    "profile.newPassword": "New password",
    "profile.renamed": "Name saved.",
    "profile.emailChanged": "E-mail changed. Sign in with the new address from now on.",
    "profile.passwordChanged": "Password changed. Other devices have been signed out.",
    "ws.plan.stop": "Stop-loss",
    "ws.panel.resize": "Drag to resize (double-click: default height)",
    "ws.right.collapse": "Hide the right column (wider chart)",
    "ws.right.expand": "Show the watchlist and the market, news, times and voting tabs",
    "ws.acct.menu": "Account",
    "ws.theme.toLight": "Switch to the light look",
    "ws.theme.toDark": "Switch to the dark look",
    "ws.layers.candles": "Candle structures",
    "ws.layers.candleConfirmed": "only confirmed (next candle)",
  } as Record<string, string>,
  de: {
    // die Modelle: die Wahl über dem Chart, das Feintuning daneben
    "model.label": "Modell",
    "model.none": "keins",
    "tune.auto.on": "An",
    "tune.auto.off": "Aus",
    "tune.slots": "Meine Feintunings",
    "tune.slot.name": "Name dieses Feintunings",
    "tune.slot.load": "Dieses Feintuning laden",
    "tune.slot.save": "Aktuelles Feintuning hier speichern",
    "tune.slot.reset": "Auf Voreinstellung zurücksetzen",
    "tune.slot.resetConfirm": "Speicher {n} auf seine Voreinstellung „{preset}“ zurücksetzen? Das dort gespeicherte Feintuning geht verloren.",
    "tune.slot.active": "aktiv",
    "tune.slot.failed": "Das Feintuning ließ sich nicht speichern.",
    "ws.news.headlines": "Schlagzeilen",
    "ws.cal.previous": "Vorher",
    "ws.cal.date": "Datum",
    "ws.cal.short.date": "Dat.",
    "ws.cal.short.event": "Termin",
    "ws.cal.short.actual": "Ist",
    "ws.cal.short.forecast": "Prog.",
    "ws.cal.short.previous": "Vorh.",
    "ws.cal.forecast": "Prognose",
    "ws.cal.actual": "Ist",
    "ws.cal.impact.none": "Ohne Einstufung",
    "ws.cal.impact.holiday": "Bankfeiertag",
    "ws.cal.impact.low": "Geringe Wichtigkeit",
    "ws.cal.impact.medium": "Mittlere Wichtigkeit (orange Mappe)",
    "ws.cal.impact.high": "Hohe Wichtigkeit (rote Mappe)",
    "ws.cal.none": "Keine wichtigen Termine in den nächsten Tagen.",
    "ws.cal.error": "Der Wirtschaftskalender ist gerade nicht erreichbar.",
    "ws.cal.off": "Kein Wirtschaftskalender eingerichtet (Einstellungen → Marktdaten).",
    "ws.cal.title": "Wirtschaftskalender",
    "ws.cal.now": "{title} wird gerade veröffentlicht",
    "ws.cal.next": "Nächster wichtiger Termin: {title} in {min}",
    "ws.symbol": "Instrument",
    "ws.search.placeholder": "Markt suchen (Symbol oder Name) …",
    "ws.search.noResults": "Keine Treffer",
    "ws.search.online": "Beim Datenanbieter nach „{q}“ suchen",
    "ws.search.add": "Hinzufügen",
    "ws.search.searching": "Suche …",
    "ws.timeframe": "Zeitrahmen",
    "ws.market.remove": "Markt entfernen",
    "ws.market.removeConfirm": "{name} endgültig entfernen? Kursdaten und Zeichnungen werden gelöscht; vorinstallierte Märkte bleiben.",
    "ws.watchlist": "Watchlist",
    "ws.col.price": "Kurs",
    "ws.col.change": "Änd.",
    "ws.watchlist.remove": "Aus der Watchlist entfernen",
    "ws.watchlist.empty": "Deine Watchlist ist leer. Füge über die Suche einen Markt hinzu.",
    "ws.watchlist.loading": "Watchlist wird analysiert …",
    "ws.side.panel": "Markt-Panel",
    "ws.side.watch": "Watchlist",
    "ws.side.market": "Markt",
    "mk.head": "Prüfungen · {tf}",
    "mk.long": "Long",
    "mk.short": "Short",
    "mk.none": "Noch keine Prüfungen: Der Markt hat zu wenige Kerzen.",
    "mk.about": "Zu dieser Prüfung",
    "mk.legend": "✓ erfüllt an der letzten geschlossenen Kerze, – nicht erfüllt.",
    // das Illustillo-Modell (ein Smart-Money-Prozess): Feintuning, Übersicht, Chart, Prüfungen
    "io.name": "Illustillo",
    "io.tune": "Feintuning",
    "io.title": "Illustillo-Feintuning",
    "io.about.title": "Illustillo – die Strategie",
    "io.about.intro": "Ein Smart-Money-Ablauf in sieben Schritten – jeder gilt erst nach dem vorigen.",
    "io.about.steps": "1 Bias: der letzte Strukturbruch (BOS) auf der höheren Zeitebene gibt die Richtung; ein CHoCH danach ist nur ein erstes Zeichen.\n2 Draw on Liquidity: die Box – das letzte ungebrochene Swing-Hoch (Decke) und Swing-Tief (Boden) der Box-Zeitebene.\n3 Sweep: eine Kerze sticht durch Liquidität und schließt wieder innerhalb.\n4 Displacement: danach ein kräftiger Bruch der inneren Struktur in Richtung der Seite (mit Auto ein CHoCH).\n5 POI: der offene Orderblock oder das Fair Value Gap, das diese Bewegung hinterlassen hat.\n6 Bestätigung: die Rückkehr in den POI (mit Auto der Einstieg selbst), sonst ein weiterer Bruch dort.\n7 Ziel: der Draw on Liquidity oder Vielfache des Risikos; mit Auto erst das London-, dann das Asien-Hoch bzw. -Tief.",
    "io.about.evidence": "Kein belegter Vorteil: Die Bausteine (Sweeps, Orderblocks, Gaps, Retest, die ICT-Abfolge) brachten auf ungesehenen Daten nichts. Eine Lesehilfe nach dem Smart-Money-Prinzip.",
    "io.auto": "Auto",
    "io.auto.session": "laufende Session: Box-Rand, Vortag, Hoch/Tief der Asien-Killzone, gleiche Hochs/Tiefs",
    "io.auto.bodies": "Körper ≥ {x} × davor",
    "io.auto.stop": "hinter dem Sweep-Extrem",
    "io.auto.targets": "London-, dann Asien-Killzone Hoch/Tief, sonst Draw on Liquidity",
    "io.targets": "Ziele",
    "io.auto.poi": "beide, im Discount / Premium, Überlappung zuerst, nächst dem EQ; Orderblock = letzte Gegenkerze",
    "io.bias": "Bias",
    "io.box": "Box",
    "io.swing": "Swings",
    "io.bars": "{n} Kerzen",
    "io.close": "Bruch durch",
    "io.close.body": "Kerzenschluss",
    "io.close.wick": "Docht",
    "io.window": "Sweep innerhalb",
    "io.displacement": "Displacement ≥",
    "io.poi": "POI",
    "io.poi.orderBlock": "Orderblock",
    "io.poi.fvg": "FVG",
    "io.poi.both": "Beide",
    "io.poiKind.orderBlock": "Orderblock",
    "io.poiKind.fvg": "Fair Value Gap",
    "io.poiKind.breaker": "Breaker",
    "io.poiKind.supplyDemand": "Angebot / Nachfrage",
    "io.entry": "Einstieg",
    "io.entry.near": "Nahe Kante",
    "io.entry.mid": "Mitte",
    "io.entry.far": "Ferne Kante",
    "io.entry.row": "Einstieg",
    "io.stop.row": "Stop",
    "io.stopAtr": "Stop-Puffer",
    "io.tp": "TP{n}",
    "io.target.dol": "Draw on Liquidity",
    "io.target.rr": "{rr} R",
    "io.rr": "{price} · CRV 1:{rr}",
    "io.frames": "Bias {bias} · Box {box}",
    "io.bias.up": "aufwärts (zuletzt {kind})",
    "io.bias.down": "abwärts (zuletzt {kind})",
    "io.bias.none": "noch keiner",
    "io.bias.turning.up": "CHoCH nach oben — wartet auf BOS",
    "io.bias.turning.down": "CHoCH nach unten — wartet auf BOS",
    "io.long": "Long",
    "io.short": "Short",
    "io.stage.none": "kein Sweep — nächste Zone im Discount / Premium als Kandidat",
    "io.stage.sweep": "Sweep, kein Displacement",
    "io.stage.displacement": "Displacement, kein POI",
    "io.stage.poi": "POI steht, wartet auf Rückkehr",
    "io.stage.inPoi": "im POI, wartet auf ChoCH",
    "io.stage.confirmed": "bestätigt",
    "io.stage.againstBias": "gegen den Bias — kein Trade",
    "io.stage.wrongSide": "POI auf der falschen Seite des Equilibriums — kein Trade",
    "io.preset.1": "Auto",
    "io.preset.2": "Tagesbias · 4H-Box",
    "io.preset.3": "Scalp 1H · 15M",
    "io.chart.poi": "POI · {side}",
    "io.chart.candidate": "Kandidat · {side}",
    "io.candidate": "{kind} (Kandidat)",
    "io.chart.stop": "{side} · Stop",
    "io.chart.tp": "{side} · TP{n} (1:{rr})",
    "chk.bias": "Bias",
    "chk.bias.hint": "Illustillo, Schritt 1 (äußere Struktur). Long ✓, solange der letzte BOS der Struktur auf der Bias-Zeitebene nach oben ging, Short ✓, solange er nach unten ging; ein CHoCH danach ist nur das erste Zeichen — der Bias bleibt unentschieden, bis ein BOS in die neue Richtung folgt. Swings sind Legs der eingestellten Größe, eine Marke bricht durch Kerzenschluss (oder Docht, nach Feintuning). Nicht dasselbe wie die Ebene „Trendrichtung (Zickzack)“: Die liest die Zeitebene des Charts nach Wenden von 3 ATR, der Bias eine höhere Zeitebene (mit Auto zwei Stufen darüber) nach ihren Strukturbrüchen — beide können in verschiedene Richtungen zeigen, etwa ein kurzer Anstieg in einem fallenden 4H. Regel der Vorlage, kein belegter Vorteil: Die Trendrichtung beschreibt die Vergangenheit, nicht die Zukunft (unsere Messung 30.10.2026).",
    "chk.dol": "Draw on Liquidity",
    "chk.dol.hint": "Illustillo, Schritt 2. Die Box: das letzte noch ungebrochene Swing-Hoch (Decke) und Swing-Tief (Boden) der Box-Zeitebene — dahinter liegen die Stops, zu denen der Kurs gezogen wird. Long ✓, solange eine Decke über dem Kurs liegt, Short ✓, solange ein Boden darunter liegt. Beschreibend: Welche der beiden zuerst bricht, ist aus dem Chart nicht vorhersagbar (unsere Messung 30.10.2026).",
    "io.chart.ceiling": "Decke",
    "io.chart.floor": "Boden",
    "chk.sweep": "Liquidity Sweep",
    "chk.sweep.hint": "Illustillo, Schritt 3. ✓, wenn eine Kerze durch Liquidität gehandelt und wieder innen geschlossen hat — darunter für Long, darüber für Short. Mit Auto nur bedeutende Liquidität und innerhalb der laufenden Session: Boden oder Decke der Box, Vortagestief/-hoch, Tief/Hoch der Asien-Killzone (20:00–00:00 New York, wie der ICT-Killzone-Indikator sie zeichnet) oder ein Swing in einem Pool gleicher Tiefs/Hochs; ohne Auto jeder Swing der inneren Struktur innerhalb des eingestellten Fensters. Die Vorlage: „Der Sweep ist oft das Einstiegssignal.“ Gemessen 30.10.2026 auf 12 Märkten: Ein Sweep allein ändert die Quoten nicht.",
    "chk.displacement": "Displacement",
    "chk.displacement.hint": "Illustillo, Schritt 4. ✓, wenn nach dem Sweep die innere Struktur mit einer starken Bewegung in Richtung der Seite gebrochen ist: mit Auto ist der Bruch ein Change of Character (Einstiegsbeispiel der Vorlage: „4) CHOCH“) und ihr größter Kerzenkörper (Vorlage: „große Kerzen … deutlich stärker“) ist mindestens das eingestellte Vielfache des mittleren Körpers der 20 Kerzen vor dem Sweep, ein Fair Value Gap ist keine Pflicht (es entsteht nur „oft“); ohne Auto ist die Bewegung vom Extrem des Sweeps bis zum Schluss der Bruchkerze mindestens das eingestellte Vielfache der ATR 14 lang. Die Vorlage: „Beweis, dass Smart Money schiebt — ohne Displacement Vorsicht.“ Unsere Messung: Ausbrüche auf 5M laufen seltener weiter als der Zufall (33 % gegen 36 %).",
    "chk.poi": "Point of Interest",
    "chk.poi.hint": "Illustillo, Schritt 5. ✓, wenn das Displacement einen Orderblock oder ein Fair Value Gap (nach Feintuning) in Richtung der Seite hinterlassen hat, das noch offen ist — das früheste, der Ursprung der Bewegung; mit Auto nur auf der richtigen Seite des Box-Equilibriums (Long im Discount, Short im Premium), eine Überlappung beider Arten zuerst; der Orderblock ist die letzte Gegenkerze vor der Bewegung, wie ihn die Ebene Order Blocks zeichnet. An ihm hängt der Plan: Einstieg an seiner Kante, Stop hinter seiner fernen Kante. Gemessen 30.10.2026: Reaktionen an Orderblocks und Gaps liegen auf ungesehenen Daten beim Zufall. Die Zone zeichnet das Modell im Chart.",
    "chk.confirm": "Bestätigung",
    "chk.confirm.hint": "Illustillo, Schritt 6. ✓, wenn der Kurs in den POI zurückgekehrt ist (Mitigation) und danach die innere Struktur in Richtung der Seite gebrochen hat — mit Auto die Rückkehr selbst, wie das Einstiegsbeispiel der Vorlage einsteigt: sein ChoCH ist der Bruch des Displacements vor der Rückkehr („4) CHOCH“, „5) Returns to Bullish OB“). Der Plan: Einstieg an der POI-Kante; mit Auto der Stop hinter dem Extrem des Sweeps (oder der fernen POI-Kante, was weiter weg liegt) plus Puffer und die Ziele das Hoch der London-Killzone (02:00–05:00 New York), dann der Asien-Killzone (Short: Tiefs) jenseits des Einstiegs, sonst der Draw on Liquidity (Beispiel der Vorlage); ohne Auto der Stop hinter der fernen POI-Kante plus Puffer und die Ziele wie eingestellt. Gemessen 30.10.2026 als komplettes Setup: kein Vorteil auf ungesehenen Daten. Stop und Ziele zeichnet das Modell im Chart.",
    "ws.side.news": "News",
    "ws.side.times": "Zeiten",
    "ws.side.votes": "Voting",
    "ws.side.noMarket": "Wähle einen Markt aus der Watchlist – hier erscheinen seine News, Handelszeiten und das Voting.",
    "ws.time.holiday": "Heute Bankfeiertag in {places} — dort dünner Handel, sprunghafte Bewegungen möglich.",
    "ws.place.newYork": "New York",
    "ws.place.london": "London",
    "ws.place.frankfurt": "Frankfurt",
    "ws.place.tokyo": "Tokio",
    "ws.time.sessions": "Handelssitzungen",
    "ws.time.s.sydney": "Sydney",
    "ws.time.s.tokyo": "Tokio",
    "ws.time.s.london": "London",
    "ws.time.s.newyork": "New York",
    "ws.time.openUntil": "offen · schließt {in}",
    "ws.time.opensIn": "öffnet {in}",
    "ws.time.inHm": "in {h} Std. {m} Min.",
    "ws.time.inM": "in {m} Min.",
    "ws.time.src.babypips": "Babypips",
    "ws.time.src.jpx": "JPX",
    "ws.time.src.xetra": "Xetra",
    "ws.time.src.lse": "LSE",
    "ws.time.src.lbma": "LBMA",
    "ws.time.src.usStats": "BLS/BEA",
    "ws.time.src.nyse": "NYSE",
    "ws.time.src.lseg": "LSEG",
    "ws.time.src.cme": "CME",
    "ws.time.keyTimes": "Wichtige Zeiten",
    "ws.source": "Quelle: {source}",
    "ws.sourceOf": "Quelle zu „{title}“",
    "ws.time.k.sydneyOpen": "Sydney öffnet",
    "ws.time.kd.sydneyOpen": "Der Forex-Tag beginnt mit Sydney um 17:00 New York; Gold öffnet nach seiner Tagespause erst um 18:00 New York",
    "ws.time.k.lbmaAm": "LBMA-Goldauktion (vormittags)",
    "ws.time.kd.lbmaAm": "Londoner Goldpreis-Auktion, 10:30 London — der Referenzpreis für Gold",
    "ws.time.k.lbmaPm": "LBMA-Goldauktion (nachmittags)",
    "ws.time.kd.lbmaPm": "Londoner Goldpreis-Auktion, 15:00 London — oft mehr Volumen als am Vormittag",
    "ws.time.k.fxFix": "Londoner Devisen-Fixing",
    "ws.time.kd.fxFix": "WM/Reuters-Schlusskurse, 16:00 London — große Währungsorders, oft heftige Bewegungen darum",
    "ws.time.k.tokyoOpen": "Tokio öffnet",
    "ws.time.kd.tokyoOpen": "Beginn der Asien-Sitzung",
    "ws.time.k.frankfurtOpen": "Frankfurt öffnet",
    "ws.time.kd.frankfurtOpen": "Xetra öffnet, 09:00 Frankfurt — der DAX startet, das Euro-Volumen steigt",
    "ws.time.k.lbmaSilver": "LBMA-Silberauktion",
    "ws.time.kd.lbmaSilver": "Londoner Silberpreis-Auktion, 12:00 London — der Referenzpreis für Silber",
    "ws.time.k.lbmaPgmAm": "LBMA Platin/Palladium (vormittags)",
    "ws.time.kd.lbmaPgmAm": "Londoner Platin- und Palladiumpreis-Auktion, 09:45 London",
    "ws.time.k.lbmaPgmPm": "LBMA Platin/Palladium (nachmittags)",
    "ws.time.kd.lbmaPgmPm": "Londoner Platin- und Palladiumpreis-Auktion, 14:00 London",
    "ws.time.k.londonOpen": "London öffnet",
    "ws.time.kd.londonOpen": "Beginn der London-Sitzung, das Volumen steigt",
    "ws.time.k.usData": "US-Wirtschaftsdaten",
    "ws.time.kd.usData": "CPI, Arbeitsmarktbericht und andere US-Daten kommen meist jetzt — starke Bewegungen möglich",
    "ws.time.k.nyOpen": "New-York-Börseneröffnung",
    "ws.time.kd.nyOpen": "Die US-Aktienbörsen öffnen — oft kräftige Bewegungen",
    "ws.time.k.dailyBreak": "Tagesschluss",
    "ws.time.kd.dailyBreak": "Gold und Devisen pausieren eine Stunde; die Spreads werden davor und danach breiter",
    "ws.acct.settings": "Einstellungen",
    "ws.layers.title": "Ebenen",
    "ws.grid.help": "Hintergrund-Raster: aus, waagerecht (Preisstufen), senkrecht (Zeitstufen) oder kariert",
    "ws.grid.label": "Raster",
    "ws.fullscreen.enter": "Vollbild",
    "ws.fullscreen.exit": "Vollbild beenden",
    "ws.zone.label": "Zeitzone",
    "tz.local": "Gerätezeit",
    "tz.UTC": "UTC",
    "tz.America/New_York": "New York",
    "tz.America/Chicago": "Chicago",
    "tz.Europe/London": "London",
    "tz.Europe/Berlin": "Berlin / Frankfurt",
    "tz.Europe/Moscow": "Moskau",
    "tz.Asia/Dubai": "Dubai",
    "tz.Asia/Hong_Kong": "Hongkong",
    "tz.Asia/Singapore": "Singapur",
    "tz.Asia/Tokyo": "Tokio",
    "tz.Australia/Sydney": "Sydney",
    "ws.crosshair.label": "Fadenkreuz",
    "ws.crosshair.help": "Fadenkreuz an: Linien durch den Zeiger mit Preis und Zeit an den Achsen — aus: der Chart ohne sie (die Zeile darüber zeigt weiter die Kerze unter dem Zeiger)",
    "ws.magnet.label": "Magnet",
    "ws.magnet.help": "Magnet an: Das Fadenkreuz haftet an der Kerze darunter (Eröffnung, Hoch, Tief oder Schluss) — aus: frei beweglich über den Chart",
    "ws.grid.off": "aus",
    "ws.grid.horizontal": "waagerecht",
    "ws.grid.vertical": "senkrecht",
    "ws.grid.both": "kariert",
    "ws.layers.last": "Aktueller Kurs (Linie zur Achse)",
    "ws.layers.group.fib": "Fibonacci",
    "ws.layers.group.levels": "Level & Zonen",
    "ws.layers.group.structure": "Struktur & Trend",
    "ws.layers.group.smc": "Smart Money",
    "ws.layers.group.patterns": "Chartmuster",
    "ws.layers.group.indicators": "Indikatoren",
    "ws.layers.group.time": "Zeit & News",
    "ws.layers.group.candles": "Kerzen",
    "ws.layers.group.view": "Darstellung",
    "ws.layers.levels": "Unterstützung / Widerstand / Liquidität",
    "ws.layers.fvg": "Fair Value Gaps",
    "ws.layers.orderBlocks": "Order Blocks",
    "ws.layers.breakers": "Breaker Blocks",
    "ws.layers.poi": "POI (Point of Interest)",
    "ws.layers.supplyDemand": "Angebot / Nachfrage (Seiden)",
    "ws.layers.srZones": "Unterstützungs- / Widerstandszonen",
    "ws.layers.fibClusters": "Fibonacci-Cluster (Boroden)",
    "ws.layers.premiumDiscount": "Premium / Discount",
    "ws.layers.events": "Struktur (Sweep / BOS)",
    "ws.layers.chains": "Entry-Kette (Sweep → MSS → FVG)",
    "ws.layers.swingStructure": "Swing-Struktur (HH / HL, extern)",
    "ws.layers.breakRetest": "Break & Retest",
    "ws.layers.doubleTops": "Double / Triple Top / Bottom",
    "ws.layers.ifvg": "Inverse FVG",
    "ws.layers.displacement": "Displacement",
    "ws.layers.ote": "OTE-Zone (62–79 %)",
    "ws.layers.killzones": "Killzones (London, New York)",
    "ws.layersHint.events": "BOS: Bruch des letzten Hochs / Tiefs (Trend läuft weiter) · CHoCH: erster Bruch gegen den Trend (Wende) · Sweep: Docht über ein Hoch / unter ein Tief, Schluss zurück (Stops abgeholt)",
    "ws.layersHint.chains": "Das SMC-Entry-Modell: ① ein Swing-Tief (-Hoch) wird abgeholt, ② binnen 24 Kerzen ein CHoCH in die Gegenrichtung mit Fair Value Gap (der MSS), ③ der Preis läuft zurück ins Gap, ④ eine Kerze schließt heraus — der Einstieg, der Stop am Sweep. ✗ ein Schluss unter dem Sweep oder dem Gap vor dem Einstieg. Auf den Kerzen des Charts, nur aus vergangenen Kerzen.",
    "ws.layersHint.swingStructure": "Die großen Swings (Swing-Struktur, 50 Kerzen) beschriftet als HH / HL / LH / LL gegenüber dem Swing davor, dazu die Brüche dieser externen Struktur (BOS / CHoCH ext.) — interne Brüche sind Frühhinweise, diese bestätigen den übergeordneten Trend.",
    "ws.layersHint.breakRetest": "Nach einem BOS kommt der Preis binnen 24 Kerzen zum gebrochenen Level zurück und der Schluss hält auf der neuen Seite: aus Widerstand wurde Unterstützung (oder umgekehrt). Ein Schluss zurück durch das Level vorher ist ein Fakeout und wird nicht markiert.",
    "ws.layersHint.doubleTops": "Zwei (drei) aufeinanderfolgende Swing-Hochs (-Tiefs) auf gleicher Höhe — innerhalb der Toleranz gleicher Hochs — mit der Nackenlinie dazwischen; bestätigt erst mit Schluss durch die Nackenlinie, ungültig mit Schluss jenseits der Tops.",
    "ws.layersHint.ifvg": "Ein Fair Value Gap, durch das ein Schluss ganz hindurchging, wird zur Zone der Gegenseite (ein gebrochenes bullisches Gap: Widerstand), bis ein Schluss wieder hindurchgeht.",
    "ws.layersHint.displacement": "Die Impulskerze eines Fair Value Gaps: ihr Körper in Richtung des Gaps mindestens eine ATR und zwei Drittel der Kerze.",
    "ws.layersHint.ote": "Der Optimal Trade Entry mancher ICT-Regelwerke: 62–79 % des Anstiegs (Kaufzone) und des Falls (Verkaufszone) des 1. Fibonacci-Netzes.",
    "ws.layersHint.killzones": "ICTs Killzones in New-York-Zeit: London 02:00–05:00 und New York AM 07:00–10:00, auf Charts bis 1H — je als Box über der darin gehandelten Spanne.",
    "ws.layersHint.poi": "Wo die Bewegung begann, die die Struktur gebrochen hat (BOS / CHoCH): ihr Order Block oder Fair Value Gap, noch offen und noch nicht wieder angelaufen – grün unter dem Kurs für Käufe, rot darüber für Verkäufe. Kommt der Kurs dorthin zurück, ist das der übliche Einstieg; einmal berührt, wird er nicht mehr gezeigt.",
    "ws.layers.ema": "EMA 20 / 50 / 200 (Golden / Death Cross)",
    "ws.layers.trendZigzag": "Trendrichtung (Zickzack)",
    "ws.layers.ribbon": "MA-Ribbon",
    "ws.layers.pivots": "Pivot Points (klassisch)",
    "ws.layers.priceGaps": "Kurslücken",
    "ws.layers.trendlines": "Trendlinien (automatisch)",
    "ws.layers.headShoulders": "Head & Shoulders",
    "ws.layers.triangles": "Dreiecke & Keile",
    "ws.layers.divergences": "RSI-Divergenzen",
    "ws.layers.squeeze": "Bollinger-Squeeze",
    "ws.layersHint.trendZigzag": "Der Trend per Directional Change (Glattfelder et al. 2011): ein Anstieg gilt, bis der Kurs 3 ATR(14) unter das höchste Hoch seit der letzten Wende fällt, dann ein Fall, bis er 3 ATR über das tiefste Tief steigt; eine bestätigte Wende ändert sich nie mehr. Gezeichnet: die bestätigten Wenden bis zum laufenden Extrem als Zickzack und die Linie „Trendwende bei“, an der er kippen würde. Gemessen auf Gold 2021–26 und zehn weiteren Märkten: Von allen Live-Verfahren benennt es den im Rückblick sichtbaren Trend am besten für seine Unruhe, eine neue Richtung im Mittel nach etwa 7 Kerzen. Es beschreibt den Trend, es sagt den weiteren Verlauf nicht voraus.",
    "ws.layersHint.ema": "Die exponentiellen Durchschnitte von 20, 50 und 200 Schlusskursen; wo EMA 50 den EMA 200 kreuzt, ist das Golden Cross (nach oben) bzw. Death Cross (nach unten) markiert.",
    "ws.layersHint.ribbon": "18 exponentielle Durchschnitte von 5 bis 90 Schlusskursen unter den Kerzen, blau (kurz) bis rot (lang): im Trend aufgefächert — je breiter, desto stärker —, seitwärts und dort, wo die Richtung dreht, eng und verdreht.",
    "ws.layersHint.pivots": "Die Pivots der Parketthändler aus dem Vortag (New York): Pivot = (Hoch + Tief + Schluss) ÷ 3, darüber die Widerstände R1–R3, darunter die Unterstützungen S1–S3.",
    "ws.layersHint.priceGaps": "Eine Kerze, deren Tief über dem Hoch davor liegt (oder deren Hoch unter dem Tief davor): eine Kurslücke, offen, bis der Kurs sie ganz zurückgelaufen ist — der schon zurückgelaufene Teil wird nicht mehr gezeichnet.",
    "ws.layersHint.trendlines": "Die Unterstützungslinie durch die letzten beiden Swing-Tiefs, wenn das zweite höher liegt, die Widerstandslinie durch die letzten beiden Swing-Hochs, wenn das zweite tiefer liegt — bis zum ersten Schluss jenseits davon. Mit zwei Berührungen blass; ab der dritten (ein weiterer Swing auf der Linie) gilt sie als bestätigt und wird grün / rot.",
    "ws.layersHint.headShoulders": "Fünf Swings — Schulter, Nacken, Kopf, Nacken, Schulter: der Kopf jenseits beider Schultern, die Schultern näher beieinander als am Kopf, die Nackenlinie durch die Nacken; bestätigt erst mit Schluss durch die Nackenlinie, ungültig mit Schluss jenseits der rechten Schulter, sonst nach 48 Kerzen ausgelaufen.",
    "ws.layersHint.triangles": "Die letzten beiden Swing-Hochs und -Tiefs: flache Hochs über steigenden Tiefs (aufsteigend), flache Tiefs unter fallenden Hochs (absteigend), fallende Hochs über steigenden Tiefs (symmetrisch); steigende / fallende Keile — beide Linien in dieselbe Richtung, zusammenlaufend; der erste Schluss außerhalb ist der Ausbruch (die Linien dann grün / rot), ausgelaufen, wo sich die Linien treffen, oder nach 48 Kerzen.",
    "ws.layersHint.divergences": "RSI (14) gegen zwei aufeinanderfolgende Swings: regulär — höheres Hoch mit tieferem RSI (bärisch), tieferes Tief mit höherem RSI (bullisch); versteckt — tieferes Hoch mit höherem RSI (bärisch), höheres Tief mit tieferem RSI (bullisch).",
    "ws.layersHint.squeeze": "Bollingers Squeeze: die Breite der Bänder (20, 2) auf ihrem Tief seit 125 Kerzen ist markiert; der erste Schluss außerhalb der Bänder binnen 48 Kerzen danach ist die Auflösung.",
    "ws.layers.sessionLiquidity": "Session-Liquidität (Asien, London)",
    "ws.layers.equalLevels": "Equal Highs / Lows",
    "ws.layers.htfChains": "Entry-Kette im HTF-POI",
    "ws.layers.inducement": "Inducement",
    "ws.layers.oscillators": "Oszillator-Signale (RSI, Stochastik, MACD)",
    "ws.layers.sideways": "Seitwärtsphasen",
    "ws.layers.volume": "Volumen-Bestätigung",
    "ws.layers.channels": "Trendkanal",
    "ws.layersHint.sessionLiquidity": "Hoch und Tief der Asien- (Tokio) und der London-Sitzung, jeweils bis eine spätere Kerze sie abholt: Docht darüber und Schluss zurück ist ein Sweep, Schluss jenseits ein Bruch — auf Charts bis 1H.",
    "ws.layersHint.equalLevels": "Zwei aufeinanderfolgende Swing-Hochs (-Tiefs) auf gleicher Höhe — innerhalb der Toleranz gleicher Hochs — als Linie, bis der Kurs darüber hinausläuft: die Liquidität dort ist abgeholt.",
    "ws.layersHint.htfChains": "Die Entry-Ketten (Sweep → MSS → FVG), die in einem POI der höheren Zeitebene entstanden (unter 1H die 1H, im 1H-Chart die 4H): der POI blass gezeichnet, die Kette mit „HTF ✓“ markiert.",
    "ws.layersHint.inducement": "Zu jedem noch wartenden POI der letzte Swing zwischen Kurs und POI, der nach ihm entstand — die Stops der frühen Einstiege; markiert, wenn eine Kerze ihn abholt, bevor der Kurs den POI erreicht.",
    "ws.layersHint.oscillators": "Im Kurs-Chart, ohne eigenes Fenster: RSI 14 steigt über 70 / fällt unter 30, Stochastik 14/3/3 kreuzt über 80 / unter 20, MACD 12/26/9 kreuzt seine Signallinie.",
    "ws.layersHint.sideways": "Wo die Schlusskurse vor allem hin und her liefen — Efficiency Ratio über 20 Kerzen unter 0,16, die Regel der Trendprüfung für „kein klarer Trend“ — mindestens 10 Kerzen lang: eine blasse Box über der gehandelten Spanne.",
    "ws.layersHint.volume": "Strukturbrüche (intern und Swing), deren Kerze mindestens das 1,5-Fache des mittleren Volumens der 20 Kerzen davor handelte — bei CFDs das Tick-Volumen des Anbieters.",
    "ws.layersHint.channels": "Zu jeder automatischen Trendlinie die Parallele durch die äußerste Kerze auf der anderen Seite zwischen ihren beiden Swings: der Trendkanal, gezeichnet wie seine Trendlinie.",
    "ws.layers.news": "News-Marker",
    "ws.watchlist.searchAdd": "Markt suchen und zur Watchlist hinzufügen …",
    "ws.watchlist.dragHint": "Klicken: im Tab öffnen · ziehen: Reihenfolge ändern",
    "ws.tabs.label": "Offene Märkte",
    "ws.tabs.add": "Weiteren Markt in neuem Tab öffnen",
    "ws.empty.title": "Kein Markt geöffnet",
    "ws.empty.hint": "Wähle einen Markt in der Watchlist oder finde ihn über die Suche darüber — er öffnet sich in einem Tab.",
    "ws.tabs.close": "Tab {m} schließen",
    "ws.tabs.search": "Markt suchen …",
    "ws.layers.heikin": "Heikin-Ashi-Kerzen",
    "ws.layers.walker": "Illusman",
    "ws.layers.walkerMode": "Wie Illusman sich bewegt: von selbst (Auto), von selbst und gesteuert (Hybrid) oder nur gesteuert (Manuell: Pfeiltasten, B, J, M, Joystick)",
    "ws.layers.walkerMode.auto": "Auto",
    "ws.layers.walkerMode.hybrid": "Hybrid",
    "ws.layers.walkerMode.manual": "Manuell",
    "ws.layers.dayLevels": "Tages-Levels (New York)",
    "ws.layers.vwap": "VWAP-Band",
    "ws.layers.bollinger": "Bollinger-Bänder (20, 2)",
    "ws.lvl.pdh": "Vortageshoch",
    "ws.lvl.pdl": "Vortagestief",
    "ws.lvl.pdc": "Vortagesschluss",
    "ws.lvl.poc": "POC",
    "ws.lvl.vah": "VAH",
    "ws.lvl.val": "VAL",
    "ws.lvl.onh": "Overnight-Hoch",
    "ws.lvl.onl": "Overnight-Tief",
    "ws.lvl.orh": "OR-Hoch",
    "ws.lvl.orl": "OR-Tief",
    "ws.lvl.ibh": "IB-Hoch",
    "ws.lvl.ibl": "IB-Tief",
    "ws.lvl.wo": "Wochenöffnung",
    "ws.lvl.pwh": "Vorwochenhoch",
    "ws.lvl.pwl": "Vorwochentief",
    "ws.lvl.round": "Runde Zahl",
    "ws.layers.fibo": "Fibonacci",
    "ws.layers.fiboFirst": "1. Netz",
    "ws.layers.fiboSecond": "2. Netz",
    "ws.layers.fiboSides": "{net}: Seiten (L Long ↑, S Short ↓)",
    "ws.layers.fiboSide.long": "L",
    "ws.layers.fiboSide.short": "S",
    "ws.an.entry": "Einstieg",
    "ws.plan.side.long": "Long",
    "ws.plan.side.short": "Short",
    "notify.tip.title": "💡 Neuer Trade-Tipp",
    "notify.tip.reward": "+{r} R",
    "notify.tip.until": "Gilt für die heutige Runde bis 17:00 New York.",
    "notify.tip.vote": "Stimme in Illustrading dafür oder dagegen – anonym.",
    "notify.tip.open": "🗳 Jetzt abstimmen",
    "notify.chosen.title": "✓ Illustrading ist verbunden",
    "notify.chosen.lead": "Neue Trade-Tipps erscheinen ab jetzt hier.",
    "vote.title": "Trade-Tipps · {market}",
    "vote.endsIn": "Runde endet in {time}",
    "vote.endsAt": "Die Runde endet {end} (17:00 New York)",
    "vote.ended": "Runde beendet",
    "vote.rulesTitle": "So funktioniert das Voting",
    "vote.split": "{long} Long, {short} Short",
    "vote.sides": "Richtung der Tipps in dieser Runde",
    "vote.yours": "Dein Trade-Tipp",
    "vote.viewOnly": "Du kannst die Tipps und Abstimmungen verfolgen; Tipps abgeben und abstimmen ist für dich nicht freigeschaltet.",
    "vote.side": "Richtung",
    "vote.optional": "optional",
    "vote.pickHint": "Tippe danach in den Chart, um den Preis dort zu übernehmen",
    "vote.pickFromChart": "{field}: Preis im Chart wählen",
    "vote.give": "Tipp abgeben",
    "vote.change": "Tipp ändern",
    "vote.delete": "Löschen",
    "vote.edit": "Diesen Tipp ändern (solange er auf den Einstieg wartet)",
    "vote.editLocked": "Eingestiegen – Preise stehen fest",
    "vote.editing": "Deinen Tipp ändern",
    "vote.deleteConfirm": "Deinen Tipp löschen? Er verschwindet mit den Stimmen dazu – auch aus den früheren Runden.",
    "vote.all": "Alle Tipps ({n})",
    "vote.none": "In dieser Runde gibt es noch keine Tipps.",
    "vote.history": "Frühere Runden",
    "vote.historyNone": "Auf diesem Markt gibt es noch keine früheren Runden.",
    "vote.agree": "Dafür",
    "vote.disagree": "Dagegen",
    "vote.opinions": "{agree} dafür · {disagree} dagegen",
    "vote.guide.exampleAuthor": "Anna",
    "vote.guide.roundTitle": "Eine Runde",
    "vote.guide.round": "Jeder Markt hat je Handelstag eine Runde; sie endet um 17:00 New York – der Countdown neben der Überschrift zeigt, wie lange sie noch läuft. Bei ihrem Ende wird jeder offene Tipp endgültig ausgewertet, und eine neue Runde beginnt.",
    "vote.guide.giveTitle": "Einen Tipp abgeben",
    "vote.guide.give": "Wähle Long oder Short und gib Einstieg, Stop-Loss und mindestens TP1 an (TP2 und TP3 sind freiwillig). Klicke in ein Preisfeld und dann in den Chart, um den Preis von dort zu übernehmen. Der Einstieg muss höchstens 10 % vom Kurs entfernt sein. Du kannst je Runde beliebig viele Tipps abgeben; nach jeder Abgabe ist das Formular für den nächsten leer.",
    "vote.guide.rowTitle": "So sieht ein Tipp aus",
    "vote.guide.row": "Jeder Tipp ist eine Zeile: ▲ grün für Long, ▼ rot für Short, wann er abgegeben wurde, der Einstieg, der Stop-Loss in Rot und die Ziele in Grün („—“: nicht angegeben). Darunter die Stimmen. Bei deinen eigenen Tipps sitzen rechts der Stift und der Papierkorb.",
    "vote.guide.details": "Ein Klick auf einen Tipp rollt seine Details aus – probier es am Beispiel oben: wer ihn abgegeben hat, wie er steht, das Risiko (Einstieg bis Stop) und je Ziel die Chance in Vielfachen des Risikos (R). Ein weiterer Klick rollt sie wieder ein.",
    "vote.guide.votesTitle": "Die Stimmen",
    "vote.guide.votes": "Die anderen stimmen für oder gegen jeden Tipp – wie sicher sie den Trade einschätzen. Der Balken wächst aus der Mitte: rot nach links für die Stimmen dagegen, grün nach rechts für die dafür; die Zahlen stehen an den Enden. Hier 1 dagegen und 3 dafür. Drücke 👍 oder 👎 unter einem fremden Tipp, um abzustimmen, denselben Knopf noch einmal, um die Stimme zurückzunehmen. Abstimmen geht, bis ein Tipp endgültig ausgewertet ist; nicht bei deinen eigenen.",
    "vote.guide.sidesTitle": "Die Richtung der Runde",
    "vote.guide.sides": "Der Balken unter der Überschrift zählt die Tipps der Runde nach Seite: Short nach links, Long nach rechts – wohin die Community heute tendiert, unabhängig von den Stimmen zu einzelnen Tipps. Hier 2 Short und 5 Long.",
    "vote.guide.standTitle": "Stand und Ergebnis",
    "vote.guide.stand": "Ein Tipp zählt ab seiner Abgabe, gemessen an den Kursen danach (erreicht eine Kerze Stop und Ziel zugleich, zählt der Stop). Seinen Stand zeigen seine Details:",
    "vote.guide.stand.waiting": "Wartet auf Einstieg",
    "vote.guide.stand.waiting.means": "Der Kurs hat den Einstieg noch nicht erreicht.",
    "vote.guide.stand.running": "Läuft",
    "vote.guide.stand.running.means": "Eingestiegen; weder Stop noch ein Ziel erreicht.",
    "vote.guide.stand.runningTp": "Läuft · TP1 erreicht",
    "vote.guide.stand.runningTp.means": "Eingestiegen, TP1 (oder TP2) erreicht, die weiteren Ziele noch offen.",
    "vote.guide.stand.stop": "Stop",
    "vote.guide.stand.stop.means": "Der Stop kam vor einem Ziel: −1 R.",
    "vote.guide.stand.tp": "TP1 / TP2 / TP3",
    "vote.guide.stand.tp.means": "Das höchste vor dem Stop erreichte Ziel: so viele R, wie das Ziel in Vielfachen des Risikos vom Einstieg entfernt ist.",
    "vote.guide.stand.expired": "Abgelaufen",
    "vote.guide.stand.expired.means": "Eingestiegen, aber bis Rundenende weder Stop noch Ziel: 0 R.",
    "vote.guide.stand.missed": "Nicht eingestiegen",
    "vote.guide.stand.missed.means": "Der Einstieg wurde bis Rundenende nie erreicht: zählt nicht.",
    "vote.guide.standEnd": "Endgültig ausgewertet ist ein Tipp, sobald sein Stop kommt, sein letztes Ziel erreicht ist oder die Runde endet – danach ändert sich sein Stand nicht mehr.",
    "vote.guide.changeTitle": "Ändern und Löschen",
    "vote.guide.change": "Der Stift lädt deinen Tipp ins Formular, solange er auf den Einstieg wartet; nach dem Einstieg stehen seine Preise fest (der Stift ist dann ausgegraut). Die Stimmen zu einem geänderten Tipp verfallen, sie galten dem alten Plan. Der Papierkorb löscht deinen Tipp jederzeit – wartend, laufend oder ausgewertet, auch in früheren Runden – samt seinen Stimmen.",
    "vote.guide.namesTitle": "Wer was sieht",
    "vote.guide.names": "Alle sehen alle Tipps mit dem Namen ihres Erstellers (in seinen Details). Die Stimmen werden ohne Namen gezählt: Niemand sieht, wer wie abgestimmt hat.",
    "vote.details.show": "Klicken für die Details des Tipps",
    "vote.details.hide": "Klicken zum Einklappen",
    "vote.details.author": "Abgegeben von",
    "vote.details.status": "Stand",
    "vote.details.risk": "Risiko (Einstieg bis Stop)",
    "vote.details.reward": "Chance / Risiko",
    "vote.status.waiting": "Wartet auf Einstieg",
    "vote.status.running": "Läuft",
    "vote.status.runningTp": "Läuft · TP{n} erreicht",
    "vote.status.stop": "Stop",
    "vote.status.tp1": "TP1",
    "vote.status.tp2": "TP2",
    "vote.status.tp3": "TP3",
    "vote.status.expired": "Abgelaufen",
    "vote.status.missed": "Nicht eingestiegen",
    "vote.col.side": "Richtung",
    "vote.col.time": "Abgegeben",
    "profile.title": "Profil",
    "profile.name": "Name",
    "profile.email": "E-Mail",
    "profile.password": "Passwort",
    "profile.save": "Speichern",
    "profile.newEmail": "Neue E-Mail",
    "profile.currentPassword": "Aktuelles Passwort",
    "profile.newPassword": "Neues Passwort",
    "profile.renamed": "Name gespeichert.",
    "profile.emailChanged": "E-Mail geändert. Melde dich ab jetzt mit der neuen Adresse an.",
    "profile.passwordChanged": "Passwort geändert. Andere Geräte wurden abgemeldet.",
    "ws.plan.stop": "Stop-Loss",
    "ws.panel.resize": "Höhe ziehen (Doppelklick: Standardhöhe)",
    "ws.right.collapse": "Rechte Spalte einklappen (breiterer Chart)",
    "ws.right.expand": "Watchlist und die Reiter Markt, News, Zeiten und Voting einblenden",
    "ws.acct.menu": "Konto",
    "ws.theme.toLight": "Zum hellen Design wechseln",
    "ws.theme.toDark": "Zum dunklen Design wechseln",
    "ws.layers.candles": "Candle-Strukturen",
    "ws.layers.candleConfirmed": "nur bestätigte (nächste Kerze)",
  } as Record<string, string>,
};
